<template>
    <BaseModalWithLogo class="keywords-import-type-popup">
        <span class="keywords-import-type-popup__title">Have your keywords?</span>
        <span class="keywords-import-type-popup__description">There are two easy options to import keywords</span>

        <div class="keywords-import-type-popup__options">
            <div @click="selectedIndex = 0">
                <RadioLikeCard :is-selected="selectedIndex === 0"
                    class="keywords-import-type-popup__radio-like-card">
                    <span class="keywords-import-type-popup__option-title">Add keywords manually</span>
                    <span class="keywords-import-type-popup__option-description">Add and map up to 2,000 keywords at a
                        time.</span>
                </RadioLikeCard>
            </div>
            <div @click="selectedIndex = 1">
                <RadioLikeCard :is-selected="selectedIndex === 1"
                    class="keywords-import-type-popup__radio-like-card">
                    <span class="keywords-import-type-popup__option-title">Add keywords for me</span>
                    <span class="keywords-import-type-popup__option-description">Our experts will quickly add your
                        keywords.</span>
                </RadioLikeCard>
            </div>
        </div>
        <div class="keywords-import-type-popup__controls">
            <a target="_blank" href="https://calendly.com/audiencekey/30min"
                class="keywords-import-type-popup__link">
                <BaseMaterialDesignIcon icon="openInNew"
                    class="keywords-import-type-popup__link-icon" />
                Help me find keywords
            </a>

            <BaseButton class="keywords-import-type-popup__button"
                button-style="dark-gray"
                button-size="large"
                @click="submit">
                Next
                <BaseMaterialDesignIcon icon="arrowRight"
                    class="keywords-import-type-popup__button-icon" />
            </BaseButton>
        </div>
    </BaseModalWithLogo>
</template>

<script>
import RadioLikeCard from '@/features/agency/common/RadioLikeCard.vue'
export default {
    name: 'KeywordsImportTypePopup',
    components: {
        RadioLikeCard
    },
    data() {
        return {
            selectedIndex: 0
        }
    },
    methods: {
        submit() {
            if (this.selectedIndex === 0) {
                this.$router.push('/strategy/keyword-census#add-keywords')
                this.$emit('close');
                return;
            }
            this.$emit('addKeywordsForMe')
        }
    }
}
</script>

<style lang="scss" scoped>
.keywords-import-type-popup {
    padding: 80px 48px 36px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    box-sizing: border-box;

    &__radio-like-card {
        cursor: pointer;
    }

    &__title {
        display: block;
        font-size: 28px;
        font-weight: 600;
        color: $rfx-text-dark-high-contrast;
        margin-bottom: -12px;
    }

    &__description {
        display: block;
        font-size: 16px;
        color: $rfx-text-dark-mid-contrast;
        margin-bottom: 16px;
    }

    &__options {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    &__option-title {
        display: block;
        font-size: 20px;
        font-weight: 500;
        color: $rfx-text-dark-high-contrast;
        margin-bottom: 4px;
    }

    &__option-description {
        display: block;
        font-size: 14px;
        line-height: 143%;
        color: $rfx-text-dark-mid-contrast;
    }

    &__controls {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &__link {
        display: flex;
        align-items: center;
        gap: 4px;
        color: $rfx-text-dark-high-contrast;
        font-size: 14px;
        line-height: 100%;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    &__link-icon {
        font-size: 16px;
    }

    &__button {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 20px !important;
        padding: 9px 32px !important;
    }

    &__button-icon {
        font-size: 34px !important;
        color: white;
    }
}

</style>